import React, { Component } from 'react';
import T from 'prop-types';
import { Label, utils } from 'react-bootstrap';

// custom css classes in index.scss
utils.bootstrapUtils.addStyle(Label, 'white');
utils.bootstrapUtils.addStyle(Label, 'grey');
utils.bootstrapUtils.addStyle(Label, 'green');
utils.bootstrapUtils.addStyle(Label, 'yellow');
utils.bootstrapUtils.addStyle(Label, 'orange');
utils.bootstrapUtils.addStyle(Label, 'red');

export default class SeverityLabel extends Component {
    render() {
        return (
            <Label
                bsStyle={this.props.code && this.props.code.toLowerCase()}
                style={this.props.style}
            >
                {this.props.code && this.props.code.toUpperCase()}
            </Label>
        );
    }
}

SeverityLabel.propTypes = {
    code: T.string,
    style: T.object,
};
